import ViewBase from "../../../../framework/core/mvvm/view_base";
import VideoRewardViewItem from './videoreward_view_item';
import AppData from '../../../public/const/app_data';


const {ccclass, property} = cc._decorator;

@ccclass
export default class VideoRewardView extends ViewBase {

    @property([VideoRewardViewItem])
    rewardItems : VideoRewardViewItem[] = [];

    @property(cc.Button)
    buttonWatchVideoAdert : cc.Button = null;

    @property(cc.Label)
    labelRewardRemainingCount : cc.Label = null;

    @property(cc.Label)
    labelRewardIntervalsTime : cc.Label = null;

    @property(cc.Node)
    nodeNonInteractable : cc.Node = null;

    @property(cc.Node)
    nodeRewardFinish : cc.Node = null;

    @property(cc.Node)
    nodeTest : cc.Node = null;

    onLoad(){
        this.nodeTest.active = AppData.testMode
    }

    initData(data) {
        let showRewardCount = data.awards.length
        for (let index = 0; index < this.rewardItems.length; index++) {
            const element = this.rewardItems[index];
            if (index < showRewardCount) {
                element.node.active = true
                element.initItem(data.awards[index])
            } else {
                element.node.active = false
            }
        }
    }

    setProgressData(data) {
        this.labelRewardRemainingCount.string = "剩余次数：" + (data.dayNum - data.todayNum)
        if (data.isFinish) {
            this.labelRewardIntervalsTime.node.active = false
            this.labelRewardRemainingCount.string = "已领取全部奖励"
            this.nodeRewardFinish.active = true
            this.buttonActive(false)
        } else {
            this.nodeRewardFinish.active = false
            let time = new Date().getTime() - data.lastGetRewardTime
            cc.warn("setProgressData", new Date().getTime(), time, time - data.cdSecond, time <= data.cdSecond, Math.floor((data.cdSecond - time) / 1000), Math.ceil((data.cdSecond - time) / 1000))
            if (data.cdSecond < 1000 || time < data.cdSecond) {
                this.resetWatchVideoTime(Math.ceil((data.cdSecond - time) / 1000))
            } else {
                this.buttonActive(true)
                this.labelRewardIntervalsTime.node.active = false
            }
        }
    }

    private resetWatchVideoTime(coolingTime : number) {
        this.reset()
        if (coolingTime < 1) {
            this.buttonActive(true)
            this.labelRewardIntervalsTime.node.active = false
        } else {
            this.buttonActive(false)
            this.labelRewardIntervalsTime.node.active = true
            this.labelRewardIntervalsTime.string = coolingTime.toString()
            this.schedule(() => {
                coolingTime = coolingTime - 1
                this.labelRewardIntervalsTime.string = coolingTime.toString()
                if (coolingTime < 1) {
                    this.labelRewardIntervalsTime.node.active = false
                    this.buttonActive(true)
                }
            }, 1, coolingTime)
        }
    }

    private buttonActive(interactable : boolean) {
        this.buttonWatchVideoAdert.interactable = interactable;
        this.nodeNonInteractable.active = !interactable
    }
    
    reset() {
        this.unscheduleAllCallbacks()
    }

    

}
